export const arTexts = {
  // Titles
  encyclopediaTitle: "موسوعة",
  insuranceAndServicesTitle: "للتأمين والخدمات",
  generatorTitle: "مولدات",
  home: "الصفحة الرئيسية",
  contactUs: "اتصل بنا",
  loginRegister: "دخولتسجيل",
  encyclopedia: "موسوعة",
  vr: "الواقع الافتراضي",
  buy: "يشترى",
  loading: "جار التحميل",
  rugGenerate: "تنسيق السجادة",
  insuranceAndServices: "التأمين والخدمات",
  insurance: "تأمين",
  brand: "العلامة التجارية",
  shaneh: "القصب",
  density: "كثافة",
  yarn: "غزل",
  rug_size_6: "حجم السجادة 6",
  rug_size_9: "حجم السجادة 9",
  rug_size_12: "حجم السجادة 12",
  decoration: "زخرفة",
  room_services: "خدمات:",
  floor_covering: "أرضية",
  wall: "حائط",
  roof: "سقف",
  selectImage: "اختر صورة",
  wishListText:
    "يمكنك إضافة السجاد الذي تم إنشاؤه إلى قائمة المفضلة لمشاهدة معاينة لهم لاحقًا",
  services: "خدمات",
  specialPosts: "الوظائف الخاصة",
  preview: "معاينة",
  lachakToranj: "لاتشاك تورانج",
  modern: "عصري",
  afshan: "أفشان",
  kheshti: "خشتي",
  border: "الحدود",
  corner: "ركن",
  background: "خلفية",
  toranj: "تورانج",
  tile: "بلاط",
  pattern: "نمط",
  rugSettings: "بلاط",
  wishList: "قائمة الرغبات",
  addToWishList: "أضف إلى قائمة الامنيات",
  listIsEmpty: "القائمة فارغة",
  rotate: "استدارة",
  clear: "واضح",
  latest: "آخر",
  oldest: "الأقدم",
  onSale: "للبيع",
  searchingForSellers: "البحث عن البائعين",
  storesForThisRug: "مخازن لهذه البساط",
  noStoreForSelectedRug: "لا يوجد متجر للسجاد المحدد",
  selectOneSimilarRug: "حدد سجادة واحدة مماثلة",
  selectedRugs: "السجاد المختار",
  rugSimilarityPercentage: "النسبة المئوية لتشابه البساط",
  similarRugs: "سجاد مماثلة",
  availableRugSizes: "مقاسات البساط المتوفرة",
  phoneNumber: "رقم الهاتف",
  address: "عنوان",
  filters: "عوامل التصفية",
  previewEmptyHelpText: "معاينة نص التعليمات الفارغ",

  // Texts

  landingText: `يعد خلق قيمة مضافة لعملية الشراء أحد الاهتمامات الرئيسية لأي عمل تجاري. يمكن فحص هذه القيمة المضافة والعمل على أساسها بثلاث طرق. من وجهة نظر المستهلك ، البائع والمنتج في النهاية ، هدف غاليشين هو خلق هذه القيمة المضافة في منصة رقمية وآمنة. نهجنا هو عرض بيع وشراء"سلع السجاد" في بيئة جديدة وموثوقة`,
  wikipediaBoldText: `ما هو الفرق بين السجاد المصنوع آليًا والسجاد اليدوي؟ ما الذي يجب علي الانتباه إليه عند اختيار سجادة عالية الجودة؟ كيف اختار مقاس السجادة؟ ما هو لون السجاد المناسب لديكورتي؟ ماذا يعني المشط والكثافة في سجادة السيارة؟ ماذا يعني راج في عقد اليد؟`,
  wikipediaLightText: `المعلومات الكافية قبل الشراء هي أحد متطلبات شراء أي منتج. يسعى غاليشين في قسم الموسوعات إلى الإجابة عن أسئلتك وتقديم أدق المعلومات حول المواد والتصميم والأناقة والألياف واللون والأبعاد وتصميم السجاد والبساط`,
  layOutBoldText: `كيف كانت سجادة جاري؟ هل توافق على أن خلفية سجادته كانت مشابهة جدًا لديكور منزلنا؟أتمنى أن أتمكن من رؤية تفاصيل السجاد بعناية دون التجول في السوق من المنزل وعدم إزعاج البائعين`,

  layOutLightText: ` تخطيط السجاد هو خدمتنا الخاصة والحصرية لمن يهتم باللعب بتفاصيل سجادته والعثور على أقرب سجادة من اختيارهم وتجهيزها من أقرب سجادة لحل محل إقامتهم`,
  VRBoldText: `أتمنى أن نقول أحضر جميع السجاد الأربعة إلى المنزل وسنختار واحدة. هل تتناسب السجادة الحديثة مع ديكورنا أكثر أم التقليدية؟ هل ستكون السجادة على الباركيه جيدة؟`,

  VRLightText: `ربما حدث لك أنك عند شرائك للسجاد تعجبك بعض التصميمات ، لكن لا يمكنك نشر كل هذه السجاد في منزلك ورؤية مظهرها مع ديكور منزلك واختيار الخيار الأفضل. لديه العديد من الأفكار لهذه الحاجة لك. محاكاة منزلك هي بداية هذا المسار وستستمر`,
  shoppingBoldText: `هل تعرف من الذي تشتري؟ هل يمكن الوثوق بها ، أليس هذا خدعة ، هل يرسلون السجادة؟ أليس من الأفضل الشراء شخصيًا؟`,
  shoppingLightText: `لطالما كان إنشاء منصة آمنة للتجارة مصدر قلق للمستهلكين والبائعين. تعد الثقة في بيئة المبيعات عبر الإنترنت أكثر تعقيدًا بكثير ، وهذا أحد العقبات التي تحول دون توسع هذا السوق ، خاصة بالنسبة للمنتجات القيمة. حاول Galichin توفير منصة مبيعات آمنة وموثوقة لشراء السجاد للمستهلكين وبيع السجاد للموردين من خلال إنشاء آليات مناسبة`,
  insuranceBoldText: `أتمنى أن يقوم البائع بغسل السجاد بشكل دوري؟ أين يمكنني غسل السجادة حتى لا تفسد؟ أتمنى أن يأخذوا سجادتنا القديمة ويستبدلونها بأخرى جديدة مقابل مبلغ معين!هل يوجد مكان يمكنني استئجار سجادة فيه؟ هل يستأجرون سجادًا جديدًا؟`,

  insuranceLightText: `خدمة ما بعد البيع وضمان السلع القيمة مثل السجاد ستجعل التسوق أكثر متعة وأمانًا لكل عميل. وفقًا لاحتياجات العملاء ، مع تقديم خدمات ما بعد البيع المختلفة ، تقدم غاليشين خدمات أخرى قيّمة. خدمات مثل الغسيل المجاني! استبدل سجادتك القديمة بأخرى جديدة! وخدمة تأجير السجاد لاستخدامك قصير الأمد للسجاد !!!`,

  insuranceText: `نحن مهتمون جميعًا بالشراء من مكان يقدم لنا أفضل الخيارات عند الشراء ووقت خدمة ما بعد البيع. كما يقدم غاليشين خدمات متنوعة في هذا الصدد. على سبيل المثال ، المستهلك. الشخص الذي اشترى يمكن للسجادة من غاليشن مع التأمين الاستفادة من أول غسل مجاني لسجادته أو بعد فترة سيحصل على سجادة جديدة بدفع جزء من التكلفة ، خدمة تأجير السجاد هي خدمة أخرى سيتم إطلاقها قريباً`,

  servicesText: `نحن مهتمون جميعًا بالشراء من مكان يقدم لنا أفضل الخيارات عند الشراء ووقت خدمة ما بعد البيع. كما يقدم غاليشين خدمات متنوعة في هذا الصدد. على سبيل المثال ، المستهلك. الشخص الذي اشترى يمكن للسجادة من غاليشن مع التأمين الاستفادة من أول غسل مجاني لسجادته أو بعد فترة سيحصل على سجادة جديدة بدفع جزء من التكلفة ، خدمة تأجير السجاد هي خدمة أخرى سيتم إطلاقها قريباً`,
  firstLandingText: `مرحبًا بكم في الرحلة الافتراضية لعميل موقع Qalichin.
  في هذه الرحلة ، نحن معكم في خمسة أقسام.
  الخطوة الأولى هي الحصول على معلومات صحيحة وموثوقة في الموسوعة. الخطوة الثانية هي جعل شراء سجادة جذابة بالنسبة لك من خلال خدمة ترتيب السجاد التي تتيح لك تخصيص السجادة. الآن ، في الخطوة الثالثة أو الواقع الافتراضي ، لمزيد من اليقين وشراء افتراضي أكثر أمانًا ، ننتقل إلى أجهزة محاكاة ثنائية وثلاثية الأبعاد حيث يمكنك تحضير السجادة بشكل أكثر انسجامًا مع ديكور منزلك. حسن جدا. لقد حددت اختيارك ، حان الوقت الآن لدفع الثمن. الخطوة الرابعة لشراء السجاد هي سوق السجاد حيث تجد أفضل سعر من أقرب مكان وتضع طلبًا.  مبروك ، لقد تم إضافتك إلى قبيلة قاليشين. نعم ، هذا صحيح ، الخطوة الخامسة في هذه الرحلة تبدأ بعد الشراء ، والخطوة الخامسة هي التأمين والخدمات التي هي التزاماتنا تجاهك ، كعضو جديد في Qalichin.
  نحن سعداء جدًا لأنك اخترت Qalichin وأصبحت رفيقنا في السفر
  نأمل أن يكون لديك تسوق جيد وأن تستمتع برحلتك.
  حدد القسم الذي تريده من شريط الأدوات أعلاه.`,
  encyclopediaEndText: ` موسوعة:
  <br/>
  من القماش إلى النمط
  <br/>
  الخطوة الأولى في أي عملية شراء هي الحصول على معلومات كافية حول المنتج.
  مصدر المعلومات الأول لدينا عند شراء منتج هو البائعون. الآن هناك سؤال ، هل كل المعلومات التي يقدمها لنا البائعون صحيحة وموثوقة ، أم أننا بحاجة إلى مصدر أكثر موثوقية لاتخاذ القرار؟
  يعد وجود مساحة وسائط متعددة لتقديم منتجات المنسوجات والسجاد على وجه الخصوص من قبل المصنعين والبائعين وتوفير مساحة للمستهلكين لمشاركة آرائهم والتعبير عن تجارب التسوق الخاصة بهم نقطة قوية للتسوق الآمن.
  <br/>
  بعض الأمثلة على المزايا التنافسية المقدمة في مثل هذه المنصة: من وجهة نظر المستهلكين:
  <br/>
  هل كل البائعين صادقين معك؟
  هل كل المعلومات التي يقدمونها لك صحيحة؟
  <br/>
  من وجهة نظر البائع:
  <br/>
  هل يتم تقديم منتجات متجرهم بأفضل طريقة؟
  هل يعرفهم المجتمع الإحصائي بشكل صحيح؟
  <br/>
  من وجهة نظر المنتجين:
  <br/>
  هل الميزة التنافسية للمنتجات التي ينتجونها معروضة ومعروفة بشكل كافٍ؟
  هل يحتاجون إلى تقديمهم في مساحات جديدة؟`,
  generatorEndText: `ترتيب السجاد:
  <br/>
  السجاد والأنماط
  <br/>
  الخطوة الثانية لعملية شراء آمنة وموثوقة هي جعل شراء المنتج واختياره ممتعًا ، وليس بسبب التعب والإدانة أو الاضطرار إلى الاختيار.
  
  نحن جميعًا على دراية بالسجاد وتصميمه ودوره منذ الصغر وفقًا لخلفيتنا الثقافية وأسلوب حياتنا
  تتيح لنا هذه الإلمام البصري أن نكون خبراء سجاد خبراء عند شراء السجاد
  إذا كان من الممكن لنا جميعًا أن يكون لنا يد في تصميم السجاد ، فإننا بالتأكيد سنستفيد من هذه الفرصة.
  حتى نتمكن من الوصول إلى خطة أفضل من تصميم السجاد لدينا أو وضع خطتنا الشخصية على المحك والخطط الإيرانية الأصيلة. في قسم تخطيط السجاد ، تم إنشاء هذه الإمكانية المبهجة لك لتخصيص تصميمك ونمطك والوصول إلى تصميمك المفضل بسهولة أكبر من خلال اللعبة المتنوعة لاختيار الخريطة.
  بالإضافة إلى ذلك ، سيكون من السهل تحليل وفحص إمكانية نسيج خريطتك الحصرية مع بعض العوامل البسيطة
  <br/>
  بعض الأمثلة على المزايا التنافسية المقدمة في مثل هذه المنصة:
  <br/>
  من وجهة نظر المستهلكين:
  <br/>
  يمكن تغيير خرائط السوق وتخصيصها.
  <br/>
  يتم فحص الخريطة التي صممها العميل مع الخرائط المتوفرة في السوق ويتم تقديم أقرب الخرائط للعميل من وجهة نظر البائع:
  <br/>
  لعبة تنويع عملية الشراء وجعل عملية اختيار السجاد أكثر جاذبية
  مشاركة ذوق العميل في عملية الشراء وتسهيل اختيار السجاد
  <br/>
  من وجهة نظر المنتجين:
  <br/>
  تحليل ذوق العميل بناءً على القطع المختارة وتوجيه وحدة التصميم نحو اتجاه السوق
  استهداف إنتاج وعرض منصة النسيج للخرائط الحصرية للعملاء في شكل إصدار محدود`,
  vrEndText: `الواقع الافتراضي:
  <br/>
  السجاد والديكورات
  <br/>
  الخطوة الثالثة في رحلة السجاد الافتراضية هي المحاكاة بأدوات ثنائية وثلاثية الأبعاد وإنشاء جولات افتراضية للمتاجر التي قد لا تكون قريبة منك ، لكنك مهتم بزيارتها.
  <br/>
  دائمًا ما يكون تنسيق المنتج مع المنتجات المنزلية الأخرى أحد الاهتمامات عند شراء منتج
  الآن وقد حان الوقت لاختيار السجاد ، سيكون هذا التنسيق أكثر أهمية لأن مسألة تنسيق السجادة مع ديكور المنزل في المنتصف. أحد الحلول هو السجاد في المنازل.
  ولكن عندما يكون عدد الخطط كبيرًا ويكون نقل السجاد مشكلة ، تدخل التكنولوجيا حيز التنفيذ وتوفر حلولًا أبسط.
  <br/>
  بعض الأمثلة على المزايا التنافسية المقدمة في مثل هذه المنصة: من وجهة نظر المستهلك:
  <br/>
  شاهد المنتجات المعروضة في المتاجر دون الحاجة للسفر
  عرض جميع أنواع تصميمات السجاد بالمكان المطلوب باستخدام أدوات المحاكاة
  <br/>
  من وجهة نظر الموزع:
  <br/>
  الاستفادة من المنصات البرمجية لجذب المزيد من الزيارات لمتجرهم
  استخدام الأنظمة التكنولوجية لتقليل تكلفة السجاد في منزل العميل
  <br/>
  من وجهة نظر المنتج:
  <br/>
  قم بإنشاء جولة افتراضية للمصنع واعرض المنتجات لشبكة تجار الجملة
  تقصير وتبسيط عملية طلب المنتجات لأصحاب المتاجر الذين يجدون صعوبة في زيارة المصنع`,
  buyEndText: `يشتري:
  <br/>
  السجاد والمخازن
  <br/>
  تتمثل الخطوة الرابعة في رحلة Qalichin الافتراضية في توفير سوق افتراضي أو سوق للعلامات التجارية
  <br/>
  بعد المراحل الثلاث السابقة في هذه الرحلة الافتراضية إلى مرحلة الشراء ، سيكون لدى العميل مخاوف مثل السعر وجودة المنتجات المختارة.
  في هذه الحالة ، يبدو من الضروري جدًا الاستفادة من سوق يمكنه إجراء فحوصات الأسعار والجودة بأمان ودون إنفاق الوقت والمال.
  في هذا السوق ، راقب مشتريات الآخرين ، وانظر إلى رضا العملاء ، وتأكد من خدمة ما بعد البيع ، بحيث يمكنك أخيرًا تقديم طلب مناسب من منزلك براحة بال تامة.
  <br/>
  بعض الأمثلة على المزايا التنافسية المقدمة في مثل هذه المنصة: من وجهة نظر المستهلك:
  <br/>
  التحقق من سعر البضائع المطلوبة من عدة موردين
  التحقق من مصداقية ورضا العملاء لموردي السلع بناءً على مسح المشترين القدامى
  <br/>
  من وجهة نظر الموزع:
  <br/>
  تقديم منتجاتك عبر الإنترنت دون الحاجة إلى إرسال عينات أو مستودع
  تفاعل أكثر ديناميكية مع المستهلك وإطلاق وإخطار المبيعات الخاصة
  <br/>
  من وجهة نظر المنتج:
  <br/>
  توفير محفظة منتجات من المنتجين في السوق دون وسطاء وسماسرة
  الحصول على تعليقات مباشرة من المستهلك النهائي وتوجيه الإنتاج بناءً على طلب السوق`,
  insuranceEndText: `التأمين والخدمات: </br>
  السجاد والسلام
  <br/>
  الخطوة الخامسة والأخيرة في رحلة العميل الافتراضية هي إضافة المشتري إلى عشيرة كاليشيني.
  البيع ليس نهاية القصة.
  الغرض من العمل التجاري ليس بيع منتج أو خدمة عميل وإنهاء هذا التدفق ، إذا كان الأمر كذلك ، فلا يمكن استخدام كلمة نجاح لذلك.
  الغرض من إنشاء هذا القسم هو التواصل. شبكة من الخدمات والتفاعلات.
  بعد شراء سجادة ، تنشأ احتياجات مختلفة للعميل. كالغسيل وإصلاح العيوب المحتملة وإصلاح السجاد ، مع ضمان وضمان الجودة وحتى بعد استخدام السجاد لفترة من الوقت ، الحاجة إلى بيع السجاد المستعمل أو استبدال السجادة القديمة بسجادة جديدة في السوق . يمكن تقديم كل هذه الخدمات إذا كانت لدينا رؤية صحيحة لعملية البيع وأعددنا المنصات اللازمة لاستمرار عملية خدمة ما بعد البيع.
  <br/>
  بعض الأمثلة على المزايا التنافسية المقدمة في مثل هذه المنصة:
  <br/>
  من وجهة نظر المستهلك:
  <br/>
  شراء آمن ومضمون من مجموعة مع خدمات متعددة
  إنشاء منصة لسوق المنتجات المستعملة وسوق السجاد البديل
  <br/>
  من وجهة نظر الموزع:
  <br/>
  الاستفادة من شبكة مبيعات متماسكة ومستمرة
  التعريف والتعريف بنفسك للعملاء كوحدة خدمة متميزة
  <br/>
  من وجهة نظر المنتج:
  <br/>
  في عالم الأعمال سريع الخطى والتنافسي ، فإن الخدمة الأفضل والأكثر تعادلًا لعلامة تجارية أفضل ومعروفة
  توسيع وتطوير نادي العملاء`,
  welcome: `مرحًبا بكم في الرحلة االفتراضیة لعمیل موقع قالیجین.
  في هذه الرحلة ، نحن معكم في خمسة أجزاء.`,
  hande_made: "سجاد مصنوع یدویا",
  machine: "سجاد منسوج آليًا",
  first_step: `الخطوة األولى هي الحصول
  على معلومات صحیحة وموثوقة في الموسوعة.`,
  scond_step: `الخطوة الثانیة هي جعل التسوق على السجاد
  أكثر جاذبیة لك من خالل خدمات تركیب السجاد التي
  تسمح لك بتخصیص السجاد.`,
  market_carpet: "سجادة السوق",
  your_own_carpet: "سجادتك الخاصة",
  your_photo: "صورتك",
  third_step: `في المرحلة الثالثة أو الواقع االفتراضي لمزید من الثقة
  والتسوق االفتراضي
  نختار أجهزة محاكاة ثنائیة وثالثیة األبعاد تسمح لك
  بمطابقة السجادة مع الدیكور والمنزل. حسن جدا. لقد حددت
  اختیارك ، حان الوقت اآلن لدفع الثمن.`,
  virtual_tour: "جولة افتراضیة",
  threeD: "ثلاثي الأبعاد",
  Two_dimensional: "ثنائي الأبعاد",
  fourth_step: `المرحلة الرابعة لشراء السجاد هي سوق السجاد ، حیث یمكنك العثور على أفضل سعر من أقرب مركز تسوق وطلب. تهانینا ، لقد انضممت إلى عائلة قالیجین.`,
  market: "سوق",
  gazette: "مجلة",
  fifth_step: `تبدأ المرحلة الخامسة من هذه الرحلة بعد الشراء. الخطوة الخامسة هي التأمین والخدمات ، وهي التزاماتنا تجاهك أنت العضو الجدید في قالیجین`,
  secondhand: `سوق مستعملة`,
  replace: "استبدل القديم بالجديد",
  inshurance: "تأمین السجاد",
  size_selection: "اختیار الحجم",
  select_image: "اكد و ادفع",
  confirm_and_pay: "اكد و ادفع",
  selection_size_description: "الرجاء اختیار أحد أحجام السجاد التي تریدها",
  image_registration: "تسجیل الصور",
  zoom: "التكبیر",
  confirmation_and_approval: "أكد وتابع",
  name_and_lastname: "الاسم الأول واسم العائلة",
  Phone_call: "مكالمة هاتفیة",
  Address: "تبوك",
  send: "الدفع",
  ordering: "الترتیب",
  carpet_show: "عرض السجاد",
  back_market: "العودة إلى السوق",
  next: "التالي",
  previous: "سابق",
  carpet_link: "وصلة السجادة التي تریدها",
  national_Code: "رمز دولي",
  upload_photo_and_video: "قم بتحمیل الصور ومقاطع الفیدیو الخاصة بسجادتك",
  photoـorـvideoـlink: "رابط الصورة أو الفیدیو",
  coming_back: "العودة",
  the_link_of_the_carpet_you_want: "وصلة السجادة التي تریدها",
  landing_tab:
    "استخدم القائمة العلوية للحصول على مقدمة كاملة لكل قسم ، واستخدم القائمة السفلية للوصول بشكل أسرع.",
  carpet_replacement: "استبدال السجاد",
  submit: "إرسال",
  receiving_information: "تلقي المعلومات",
};
